module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.summary && _vm.isGraph) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-aqua"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.summary.totalBranches))]), _vm._v(" "), _c('p', [_vm._v("Total Branches")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-green"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.summary.totalMonths))]), _vm._v(" "), _c('p', [_vm._v("Total Months")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-yellow"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.formatCurrency(_vm.summary.totalInvoices)))]), _vm._v(" "), _c('p', [_vm._v("Total Revenue")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-xs-6"
  }, [_c('div', {
    staticClass: "small-box bg-red"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.formatCurrency(_vm.summary.totalProfit)))]), _vm._v(" "), _c('p', [_vm._v("Total Profit")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isGraph) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.records.length > 0) ? _c('apexchart', {
    attrs: {
      "type": "line",
      "height": "350",
      "options": _vm.branchMonthlyPerformanceChartData.options,
      "series": _vm.branchMonthlyPerformanceChartData.series
    }
  }) : _c('div', {
    staticStyle: {
      "height": "350px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "border": "1px solid #ddd",
      "border-radius": "4px",
      "background": "#f9f9f9"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#666"
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-2x"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("No data available")]), _vm._v(" "), _c('small', [_vm._v("Please load data to view charts")])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isGraph) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-warning"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.records.length > 0) ? _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "350",
      "options": _vm.profitLossDistributionChartData.options,
      "series": _vm.profitLossDistributionChartData.series
    }
  }) : _c('div', {
    staticStyle: {
      "height": "350px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "border": "1px solid #ddd",
      "border-radius": "4px",
      "background": "#f9f9f9"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#666"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart fa-2x"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("No data available")]), _vm._v(" "), _c('small', [_vm._v("Please load data to view charts")])])])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Branch-wise Monthly Growth Data")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export Excel\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered matrix-table text-center"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Branch Totals")]), _vm._v(" "), _vm._l((_vm.uniqueMonths), function(m) {
    return _c('th', {
      key: 'header-' + m,
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.formatMonth(m)) + "\n              ")])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Branch Totals")])], 2), _vm._v(" "), _c('tr', _vm._l((_vm.uniqueMonths), function(m) {
    return _c('th', {
      key: 'subheader-' + m
    }, [_vm._m(6, true)])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginatedPivotData), function(branch, index) {
    return _c('tr', {
      class: [
        _vm.getBranchRowClass(branch),
        _vm.isBestBranch(branch) ? 'best-branch' : '',
        _vm.isWorstBranch(branch) ? 'worst-branch' : ''
      ]
    }, [_c('td', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.perPage + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(branch ? branch.branchLocation : 'Unknown'))])]), _vm._v(" "), _c('td', {
      staticClass: "monthly-cell"
    }, [_c('div', {
      staticClass: "month-grid"
    }, [_c('div', {
      staticClass: "grid-box sales-box",
      class: (_vm.calculateBranchTotal(branch, 'totalInvoices') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("Sales")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value"
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.calculateBranchTotal(branch, 'totalInvoices'))) + " " + _vm._s(_vm.formatCurrency(_vm.calculateBranchTotal(branch, 'totalInvoices'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box pl-box",
      class: (_vm.calculateBranchTotal(branch, 'totalProfit') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("PL Amt")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value",
      class: _vm.getProfitClass(_vm.calculateBranchTotal(branch, 'totalProfit'))
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.calculateBranchTotal(branch, 'totalProfit'))) + " " + _vm._s(_vm.formatCurrency(_vm.calculateBranchTotal(branch, 'totalProfit'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box exp-box",
      class: (_vm.calculateBranchTotal(branch, 'totalExpenses') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("Exp")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value text-muted"
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.calculateBranchTotal(branch, 'totalExpenses'))) + " " + _vm._s(_vm.formatCurrency(_vm.calculateBranchTotal(branch, 'totalExpenses'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box percent-box",
      class: (_vm.calculateBranchPercentage(branch) || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("PL %")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value",
      class: _vm.getPercentageClass(_vm.calculateBranchPercentage(branch))
    }, [_vm._v("\n                      " + _vm._s(_vm.calculateBranchPercentage(branch).toFixed(1)) + "%\n                    ")])])])]), _vm._v(" "), _vm._l((_vm.uniqueMonths), function(m) {
      return _c('td', {
        key: 'combined-' + (branch ? branch.branchId : 'unknown') + '-' + m,
        staticClass: "monthly-cell"
      }, [_c('div', {
        staticClass: "month-grid"
      }, [_c('div', {
        staticClass: "grid-box sales-box",
        class: ((branch.monthlyData[m] && branch.monthlyData[m].totalInvoices) || 0) >= 0 ? 'positive' : 'negative'
      }, [_c('div', {
        staticClass: "grid-label"
      }, [_vm._v("Sales")]), _vm._v(" "), _c('div', {
        staticClass: "grid-value"
      }, [_vm._v("\n                        " + _vm._s(_vm.getTrendIcon((branch.monthlyData[m] && branch.monthlyData[m].totalInvoices) || 0)) + " " + _vm._s(_vm.formatCurrency((branch.monthlyData[m] && branch.monthlyData[m].totalInvoices) || 0)) + "\n                      ")])]), _vm._v(" "), _c('div', {
        staticClass: "grid-box pl-box",
        class: ((branch.monthlyData[m] && branch.monthlyData[m].totalProfit) || 0) >= 0 ? 'positive' : 'negative'
      }, [_c('div', {
        staticClass: "grid-label"
      }, [_vm._v("PL Amt")]), _vm._v(" "), _c('div', {
        staticClass: "grid-value",
        class: _vm.getProfitClass((branch.monthlyData[m] && branch.monthlyData[m].totalProfit) || 0)
      }, [_vm._v("\n                        " + _vm._s(_vm.getTrendIcon((branch.monthlyData[m] && branch.monthlyData[m].totalProfit) || 0)) + " " + _vm._s(_vm.formatCurrency((branch.monthlyData[m] && branch.monthlyData[m].totalProfit) || 0)) + "\n                      ")])]), _vm._v(" "), _c('div', {
        staticClass: "grid-box exp-box",
        class: ((branch.monthlyData[m] && branch.monthlyData[m].totalExpenses) || 0) >= 0 ? 'positive' : 'negative'
      }, [_c('div', {
        staticClass: "grid-label"
      }, [_vm._v("Exp")]), _vm._v(" "), _c('div', {
        staticClass: "grid-value text-muted"
      }, [_vm._v("\n                        " + _vm._s(_vm.getTrendIcon((branch.monthlyData[m] && branch.monthlyData[m].totalExpenses) || 0)) + " " + _vm._s(_vm.formatCurrency((branch.monthlyData[m] && branch.monthlyData[m].totalExpenses) || 0)) + "\n                      ")])]), _vm._v(" "), _c('div', {
        staticClass: "grid-box percent-box",
        class: ((branch.monthlyData[m] && branch.monthlyData[m].profitPercentage) || 0) >= 0 ? 'positive' : 'negative'
      }, [_c('div', {
        staticClass: "grid-label"
      }, [_vm._v("PL %")]), _vm._v(" "), _c('div', {
        staticClass: "grid-value",
        class: _vm.getPercentageClass((branch.monthlyData[m] && branch.monthlyData[m].profitPercentage) || 0)
      }, [_vm._v("\n                        " + _vm._s(_vm.getTrendIcon((branch.monthlyData[m] && branch.monthlyData[m].profitPercentage) || 0)) + " " + _vm._s(((branch.monthlyData[m] && branch.monthlyData[m].profitPercentage) || 0).toFixed(1)) + "%\n                      ")])])])])
    }), _vm._v(" "), _c('td', {
      staticClass: "monthly-cell"
    }, [_c('div', {
      staticClass: "month-grid"
    }, [_c('div', {
      staticClass: "grid-box sales-box",
      class: (_vm.calculateBranchTotal(branch, 'totalInvoices') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("Sales")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value"
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.calculateBranchTotal(branch, 'totalInvoices'))) + " " + _vm._s(_vm.formatCurrency(_vm.calculateBranchTotal(branch, 'totalInvoices'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box pl-box",
      class: (_vm.calculateBranchTotal(branch, 'totalProfit') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("PL Amt")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value",
      class: _vm.getProfitClass(_vm.calculateBranchTotal(branch, 'totalProfit'))
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.calculateBranchTotal(branch, 'totalProfit'))) + " " + _vm._s(_vm.formatCurrency(_vm.calculateBranchTotal(branch, 'totalProfit'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box exp-box",
      class: (_vm.calculateBranchTotal(branch, 'totalExpenses') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("Exp")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value text-muted"
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.calculateBranchTotal(branch, 'totalExpenses'))) + " " + _vm._s(_vm.formatCurrency(_vm.calculateBranchTotal(branch, 'totalExpenses'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box percent-box",
      class: (_vm.calculateBranchPercentage(branch) || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("PL %")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value",
      class: _vm.getPercentageClass(_vm.calculateBranchPercentage(branch))
    }, [_vm._v("\n                      " + _vm._s(_vm.calculateBranchPercentage(branch).toFixed(1)) + "%\n                    ")])])])])], 2)
  })), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "bg-light font-weight-bold"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "monthly-cell"
  }, [_c('div', {
    staticClass: "month-grid"
  }, [_c('div', {
    staticClass: "grid-box sales-box",
    class: ((_vm.summary && _vm.summary.totalInvoices) || 0) >= 0 ? 'positive' : 'negative'
  }, [_c('div', {
    staticClass: "grid-label"
  }, [_vm._v("Sales")]), _vm._v(" "), _c('div', {
    staticClass: "grid-value"
  }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon((_vm.summary && _vm.summary.totalInvoices) || 0)) + " " + _vm._s(_vm.formatCurrency((_vm.summary && _vm.summary.totalInvoices) || 0)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-box pl-box",
    class: ((_vm.summary && _vm.summary.totalProfit) || 0) >= 0 ? 'positive' : 'negative'
  }, [_c('div', {
    staticClass: "grid-label"
  }, [_vm._v("PL Amt")]), _vm._v(" "), _c('div', {
    staticClass: "grid-value",
    class: _vm.getProfitClass((_vm.summary && _vm.summary.totalProfit) || 0)
  }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon((_vm.summary && _vm.summary.totalProfit) || 0)) + " " + _vm._s(_vm.formatCurrency((_vm.summary && _vm.summary.totalProfit) || 0)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-box exp-box",
    class: ((_vm.summary && _vm.summary.totalExpenses) || 0) >= 0 ? 'positive' : 'negative'
  }, [_c('div', {
    staticClass: "grid-label"
  }, [_vm._v("Exp")]), _vm._v(" "), _c('div', {
    staticClass: "grid-value text-muted"
  }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon((_vm.summary && _vm.summary.totalExpenses) || 0)) + " " + _vm._s(_vm.formatCurrency((_vm.summary && _vm.summary.totalExpenses) || 0)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-box percent-box",
    class: (_vm.calculateOverallPercentage() || 0) >= 0 ? 'positive' : 'negative'
  }, [_c('div', {
    staticClass: "grid-label"
  }, [_vm._v("PL %")]), _vm._v(" "), _c('div', {
    staticClass: "grid-value",
    class: _vm.getPercentageClass(_vm.calculateOverallPercentage())
  }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.calculateOverallPercentage())) + " " + _vm._s(_vm.calculateOverallPercentage().toFixed(1)) + "%\n                    ")])])])]), _vm._v(" "), _vm._l((_vm.uniqueMonths), function(m) {
    return _c('td', {
      key: 'total-' + m,
      staticClass: "monthly-cell"
    }, [_c('div', {
      staticClass: "month-grid"
    }, [_c('div', {
      staticClass: "grid-box sales-box",
      class: (_vm.getMonthTotal(m, 'totalInvoices') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("Sales")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value"
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.getMonthTotal(m, 'totalInvoices'))) + " " + _vm._s(_vm.formatCurrency(_vm.getMonthTotal(m, 'totalInvoices'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box pl-box",
      class: (_vm.getMonthTotal(m, 'totalProfit') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("PL Amt")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value",
      class: _vm.getProfitClass(_vm.getMonthTotal(m, 'totalProfit'))
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.getMonthTotal(m, 'totalProfit'))) + " " + _vm._s(_vm.formatCurrency(_vm.getMonthTotal(m, 'totalProfit'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box exp-box",
      class: (_vm.getMonthTotal(m, 'totalExpenses') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("Exp")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value text-muted"
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.getMonthTotal(m, 'totalExpenses'))) + " " + _vm._s(_vm.formatCurrency(_vm.getMonthTotal(m, 'totalExpenses'))) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-box percent-box",
      class: (_vm.getMonthTotal(m, 'profitPercentage') || 0) >= 0 ? 'positive' : 'negative'
    }, [_c('div', {
      staticClass: "grid-label"
    }, [_vm._v("PL %")]), _vm._v(" "), _c('div', {
      staticClass: "grid-value",
      class: _vm.getPercentageClass(_vm.getMonthTotal(m, 'profitPercentage'))
    }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.getMonthTotal(m, 'profitPercentage'))) + " " + _vm._s(_vm.getMonthTotal(m, 'profitPercentage').toFixed(1)) + "%\n                    ")])])])])
  }), _vm._v(" "), _c('td', {
    staticClass: "monthly-cell"
  }, [_c('div', {
    staticClass: "month-grid"
  }, [_c('div', {
    staticClass: "grid-box sales-box",
    class: ((_vm.summary && _vm.summary.totalInvoices) || 0) >= 0 ? 'positive' : 'negative'
  }, [_c('div', {
    staticClass: "grid-label"
  }, [_vm._v("Sales")]), _vm._v(" "), _c('div', {
    staticClass: "grid-value"
  }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon((_vm.summary && _vm.summary.totalInvoices) || 0)) + " " + _vm._s(_vm.formatCurrency((_vm.summary && _vm.summary.totalInvoices) || 0)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-box pl-box",
    class: ((_vm.summary && _vm.summary.totalProfit) || 0) >= 0 ? 'positive' : 'negative'
  }, [_c('div', {
    staticClass: "grid-label"
  }, [_vm._v("PL Amt")]), _vm._v(" "), _c('div', {
    staticClass: "grid-value",
    class: _vm.getProfitClass((_vm.summary && _vm.summary.totalProfit) || 0)
  }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon((_vm.summary && _vm.summary.totalProfit) || 0)) + " " + _vm._s(_vm.formatCurrency((_vm.summary && _vm.summary.totalProfit) || 0)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-box exp-box",
    class: ((_vm.summary && _vm.summary.totalExpenses) || 0) >= 0 ? 'positive' : 'negative'
  }, [_c('div', {
    staticClass: "grid-label"
  }, [_vm._v("Exp")]), _vm._v(" "), _c('div', {
    staticClass: "grid-value text-muted"
  }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon((_vm.summary && _vm.summary.totalExpenses) || 0)) + " " + _vm._s(_vm.formatCurrency((_vm.summary && _vm.summary.totalExpenses) || 0)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-box percent-box",
    class: (_vm.calculateOverallPercentage() || 0) >= 0 ? 'positive' : 'negative'
  }, [_c('div', {
    staticClass: "grid-label"
  }, [_vm._v("PL %")]), _vm._v(" "), _c('div', {
    staticClass: "grid-value",
    class: _vm.getPercentageClass(_vm.calculateOverallPercentage())
  }, [_vm._v("\n                      " + _vm._s(_vm.getTrendIcon(_vm.calculateOverallPercentage())) + " " + _vm._s(_vm.calculateOverallPercentage().toFixed(1)) + "%\n                    ")])])])])], 2)])])]), _vm._v(" "), (_vm.totalBranchRows > _vm.perPage) ? _c('div', {
    staticClass: "d-flex justify-content-between align-items-center mt-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mr-2 mb-0"
  }, [_vm._v("Show:")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pageOptions,
      "size": "sm"
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("entries")])], 1), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.totalBranchRows,
      "per-page": _vm.perPage,
      "size": "sm",
      "first-number": "",
      "last-number": ""
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Showing " + _vm._s((_vm.currentPage - 1) * _vm.perPage + 1) + " to " + _vm._s(Math.min(_vm.currentPage * _vm.perPage, _vm.totalBranchRows)) + " of\n          " + _vm._s(_vm.totalBranchRows) + " entries\n        ")])], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-building"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Branch Monthly Performance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Profit/Loss Distribution")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('span', {
    staticClass: "header-left"
  }, [_vm._v("sales.")]), _vm._v(" "), _c('span', {
    staticClass: "header-right"
  }, [_vm._v("PL Amt")])]), _vm._v(" "), _c('div', {
    staticClass: "header-middle"
  }, [_c('span', {
    staticClass: "header-left"
  }, [_vm._v("-----")]), _vm._v(" "), _c('span', {
    staticClass: "header-center"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "header-right"
  }, [_vm._v("-----")])]), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('span', {
    staticClass: "header-left"
  }, [_vm._v("Exp.")]), _vm._v(" "), _c('span', {
    staticClass: "header-right"
  }, [_vm._v("PL%")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30e62b46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/growthDashboard/BranchWiseMonthlyGrowthComponent.vue
// module id = 2498
// module chunks = 0